import { render, staticRenderFns } from "./SidebarNavLink.vue?vue&type=template&id=61e22ce3"
import script from "./SidebarNavLink.vue?vue&type=script&lang=js"
export * from "./SidebarNavLink.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavLink.vue?vue&type=style&index=0&id=61e22ce3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports